import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="High_HistoryCOVID-19"
      viewBox="0 0 195.604 191.061"
      {...props}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1=".5"
          x2=".5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#f57e19" />
          <stop offset="1" stop-color="#eb5a1a" />
        </linearGradient>
      </defs>
      <g id="Group_3456" transform="translate(-174.255 -429.007)">
        <g id="Group_3066" transform="translate(180 433.834)">
          <g id="Background_Excercise" transform="rotate(14.98 18.509 140.995)">
            <g id="Group_581" transform="rotate(3 -116.754 468.856)">
              <path
                id="Path_927"
                d="M0 11.621l3.172-9.69L3.8 0a12.4 12.4 0 0 1 .269 2.027l-.053.162L1.494 9.9A17.451 17.451 0 0 1 0 11.621z"
                fill="url(#linear-gradient)"
                transform="translate(108.514 81.991)"
              />
              <path
                id="Path_928"
                d="M0 17.363L4.188 4.569 5.684 0q.286.658.507 1.295L5.035 4.827l-3.78 11.549q-.603.503-1.255.987z"
                fill="url(#linear-gradient)"
                transform="translate(105.588 78.77)"
              />
              <path
                id="Path_929"
                d="M0 21.677L4.971 6.486 7.094 0q.314.534.587 1.054l-1.863 5.69-4.642 14.184c-.383.254-.776.503-1.176.749z"
                fill="url(#linear-gradient)"
                transform="translate(102.893 76.269)"
              />
              <path
                id="Path_930"
                d="M0 25.314L5.648 8.057 8.284 0c.221.309.429.617.631.922l-2.42 7.393-5.359 16.371Q.576 25 0 25.314z"
                fill="url(#linear-gradient)"
                transform="translate(100.306 74.117)"
              />
              <path
                id="Path_931"
                d="M0 28.53l.038-.118L6.259 9.407 9.338 0c.1.125.207.254.309.383.119.151.234.3.349.452l-2.89 8.831L1.111 27.98q-.55.278-1.111.55z"
                fill="url(#linear-gradient)"
                transform="translate(97.785 72.183)"
              />
              <path
                id="Path_932"
                d="M0 31.429l.6-1.851 6.226-19.007L10.286 0c.232.246.462.5.685.753L7.673 10.83 1.452 29.837l-.359 1.1L0 31.429z"
                fill="url(#linear-gradient)"
                transform="translate(95.307 70.435)"
              />
              <path
                id="Path_933"
                d="M0 34.076l1.145-3.5 6.221-19L11.154 0q.36.337.707.684l-3.649 11.15-6.221 19-.91 2.777c-.357.161-.719.313-1.081.465z"
                fill="url(#linear-gradient)"
                transform="translate(92.856 68.85)"
              />
              <path
                id="Path_934"
                d="M0 36.532l1.662-5.078 6.221-19.006L11.958 0q.367.311.723.633L8.73 12.707l-6.221 19L1.074 36.1 0 36.532z"
                fill="url(#linear-gradient)"
                transform="translate(90.428 67.393)"
              />
              <path
                id="Path_935"
                d="M0 38.839l2.165-6.615 6.221-19.007L12.711 0c.249.192.5.39.74.587L9.233 13.476 3.012 32.483 1.07 38.419c-.356.141-.714.281-1.07.42z"
                fill="url(#linear-gradient)"
                transform="translate(88.015 66.041)"
              />
              <path
                id="Path_936"
                d="M0 41.04l2.659-8.127L8.88 13.906 13.432 0q.378.274.749.555L9.727 14.166l-6.221 19-2.441 7.46z"
                fill="url(#linear-gradient)"
                transform="translate(85.61 64.769)"
              />
              <path
                id="Path_937"
                d="M0 43.17l3.153-9.632 6.221-19L14.13 0c.254.173.507.35.759.529l-4.668 14.263L4 33.8l-2.934 8.963z"
                fill="url(#linear-gradient)"
                transform="translate(83.204 63.56)"
              />
              <path
                id="Path_938"
                d="M0 45.258l3.648-11.143L9.869 15.11 14.814 0c.257.168.51.338.766.51l-4.864 14.858-6.221 19-3.428 10.477z"
                fill="url(#linear-gradient)"
                transform="translate(80.799 62.4)"
              />
              <path
                id="Path_939"
                d="M0 47.339l4.151-12.683 6.221-19.006L15.494 0q.386.245.771.494l-5.046 15.414L5 34.915l-3.927 12q-.545.209-1.073.424z"
                fill="url(#linear-gradient)"
                transform="translate(78.386 61.277)"
              />
              <path
                id="Path_940"
                d="M0 49.456l4.675-14.28 6.221-19L16.188 0c.257.162.517.323.774.487l-5.219 15.942-6.221 19L1.084 49c-.368.149-.728.3-1.084.456z"
                fill="url(#linear-gradient)"
                transform="translate(75.952 60.174)"
              />
              <path
                id="Path_941"
                d="M0 51.66l5.231-15.981 6.223-19L16.912 0c.227.138.452.277.671.413l.1.066L12.3 16.933l-6.223 19L1.1 51.148q-.565.252-1.1.512z"
                fill="url(#linear-gradient)"
                transform="translate(73.484 59.087)"
              />
              <path
                id="Path_942"
                d="M0 54.014l5.848-17.868 6.221-19.007L17.678 0q.4.232.782.462L12.916 17.4l-6.221 19-5.564 17q-.587.305-1.131.614z"
                fill="url(#linear-gradient)"
                transform="translate(70.957 58.039)"
              />
              <path
                id="Path_943"
                d="M0 56.825l.393-1.2 6.221-19 6.221-19.005L18.6 0c.26.16.52.318.778.472l-5.7 17.4-6.221 19-6.221 19-.023.074c-.435.294-.842.585-1.213.879z"
                fill="url(#linear-gradient)"
                transform="translate(68.28 56.986)"
              />
              <path
                id="Path_944"
                d="M0 60.45l1.409-4.306L7.63 37.137l6.221-19L19.785 0q.381.254.768.5L14.7 18.39 8.477 37.4l-6.221 19-.941 2.88c-.425.37-.864.762-1.315 1.17z"
                fill="url(#linear-gradient)"
                transform="translate(65.354 55.882)"
              />
              <path
                id="Path_945"
                d="M0 64.449l2.512-7.677 6.223-19 6.221-19.007L21.1 0c.245.188.495.374.749.555L15.8 19.02 9.582 38.027 3.361 57.032 1.341 63.2Q.683 63.808 0 64.449z"
                fill="url(#linear-gradient)"
                transform="translate(62.339 54.669)"
              />
              <path
                id="Path_946"
                d="M0 68.678l3.629-11.087L9.85 38.586l6.221-19.007 6.221-19L22.48 0c.232.224.471.438.719.65l-.06.182-6.221 19.006L10.7 38.845l-6.221 19-3.138 9.585C.9 67.842.453 68.258 0 68.678z"
                fill="url(#linear-gradient)"
                transform="translate(59.312 53.267)"
              />
              <path
                id="Path_947"
                d="M0 73.115l4.71-14.393 6.221-19.007 6.221-19L23.373 1.7l.559-1.7c.207.278.43.548.666.812l-.378 1.15L18 20.969l-6.221 19-6.222 19.012L1.32 71.928c-.435.394-.872.79-1.32 1.187z"
                fill="url(#linear-gradient)"
                transform="translate(56.32 51.554)"
              />
              <path
                id="Path_948"
                d="M0 78.013l5.738-17.531 6.221-19.007 6.221-19 6.221-19L25.534 0a9.667 9.667 0 0 0 .5 1.066l.05.088-.842 2.57-6.221 19-6.221 19L6.585 60.74 1.293 76.908Q.652 77.462 0 78.013z"
                fill="url(#linear-gradient)"
                transform="translate(53.383 49.211)"
              />
              <path
                id="Path_949"
                d="M0 84.229L.469 82.8l6.221-19 6.221-19 6.22-19.02 6.221-19.005L27.569 0a14.823 14.823 0 0 0 .268 2.029l-1.638 5-6.221 19-6.221 19.016-6.221 19-6.221 19.012-.056.169C.845 83.565.423 83.9 0 84.229z"
                fill="url(#linear-gradient)"
                transform="translate(50.521 45.319)"
              />
              <path
                id="Path_950"
                d="M0 93.364l1.336-4.082 6.222-19.007 6.221-19L20 32.266l6.22-19.007L30.56 0c-.019 1.087-.1 2.215-.169 3.362l-3.324 10.155-6.221 19.007-6.221 19-6.221 19-6.221 19.017-.962 2.939q-.607.451-1.221.884z"
                fill="url(#linear-gradient)"
                transform="translate(47.741 38.251)"
              />
              <path
                id="Path_951"
                d="M0 100.649L2.112 94.2l6.221-19 6.221-19.007 6.221-19 6.221-19L32.944 0q.137 1.1.209 2.208l-5.311 16.224-6.22 19.005-6.221 19L9.18 75.449l-6.221 19-1.779 5.443q-.589.388-1.18.757z"
                fill="url(#linear-gradient)"
                transform="translate(45.055 32.755)"
              />
              <path
                id="Path_952"
                d="M0 106.29l2.8-8.55 6.221-19 6.221-19 6.221-19.007 6.221-19.005L33.9 2.712 34.791 0c.141.569.263 1.139.371 1.711l-.412 1.262-6.221 19-6.221 19-6.221 19.016-6.221 19.005L3.646 98l-2.505 7.656c-.38.218-.761.431-1.141.634z"
                fill="url(#linear-gradient)"
                transform="translate(42.458 28.626)"
              />
              <path
                id="Path_953"
                d="M0 110.855L3.389 100.5 9.61 81.492l6.22-19.005 6.221-19 6.221-19.007 6.221-19L36.284 0c.168.467.327.933.473 1.4L35.34 5.728l-6.221 19L22.9 43.74l-6.221 19-6.221 19-6.222 19.017-3.136 9.59c-.369.177-.733.347-1.1.508z"
                fill="url(#linear-gradient)"
                transform="translate(39.958 25.287)"
              />
              <path
                id="Path_954"
                d="M0 114.611l3.89-11.884 6.221-19.005 6.221-19.007 6.221-19 6.22-19.015 6.221-19L37.516 0c.19.395.37.794.541 1.192l-2.216 6.766-6.221 19-6.22 19.011-6.221 19-6.221 19.012-6.221 19-3.679 11.246q-.53.206-1.058.384z"
                fill="url(#linear-gradient)"
                transform="translate(37.544 22.474)"
              />
              <path
                id="Path_955"
                d="M0 117.71l4.3-13.132 6.221-19 6.221-19 6.221-19.007 6.221-19L35.4 9.55 38.529 0q.308.515.591 1.038l-2.87 8.77-6.222 19.007-6.221 19-6.22 19.012-6.221 19-6.221 19.01-4.128 12.612c-.339.095-.679.183-1.017.261z"
                fill="url(#linear-gradient)"
                transform="translate(35.226 20.04)"
              />
              <path
                id="Path_956"
                d="M0 120.249l4.616-14.105 6.221-19.007 6.221-19 6.221-19.007 6.221-19 6.221-19.005L39.358 0c.078.108.155.217.23.326q.2.3.4.594l-3.42 10.454-6.221 19-6.221 19-6.221 19.016-6.221 19-6.221 19.01-4.486 13.708c-.327.055-.652.101-.977.141z"
                fill="url(#linear-gradient)"
                transform="translate(32.998 17.893)"
              />
              <path
                id="Path_957"
                d="M0 122.307l4.849-14.813 6.221-19.007 6.221-19 6.221-19.005 6.221-19.007 6.221-19L40.033 0q.336.412.659.835L36.8 12.724l-6.22 19.005-6.221 19.007-6.221 19-6.221 19.012L5.7 107.753.941 122.282c-.313.018-.627.025-.941.025z"
                fill="url(#linear-gradient)"
                transform="translate(30.854 15.959)"
              />
              <path
                id="Path_958"
                d="M0 123.933l4.994-15.26 6.221-19 6.221-19.007 6.221-19 6.221-19L36.1 13.645 40.568 0c.23.249.457.5.682.76L36.947 13.9l-6.221 19.01-6.223 19-6.221 19-6.22 19.016-6.221 19L.9 124.024c-.3-.024-.6-.053-.9-.091z"
                fill="url(#linear-gradient)"
                transform="translate(28.798 14.197)"
              />
              <path
                id="Path_959"
                d="M.865 125.363c-.289-.059-.579-.125-.865-.2l5.058-15.454 6.221-19 6.221-19 6.22-19.02 6.221-19 6.221-19L40.967 0q.356.345.7.7l-4.658 14.238-6.221 19-6.221 19-6.22 19.016-6.221 19.006-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(26.824 12.58)"
              />
              <path
                id="Path_960"
                d="M.831 126.316c-.277-.095-.554-.2-.831-.312l5.042-15.4L11.263 91.6l6.221-19.01 6.221-19 6.221-19.007 6.221-19L41.245 0c.244.209.483.422.723.639l-4.974 15.193-6.221 19-6.221 19.012-6.221 19-6.221 19-6.221 19.017z"
                fill="url(#linear-gradient)"
                transform="translate(24.929 11.103)"
              />
              <path
                id="Path_961"
                d="M.795 126.911c-.266-.129-.531-.268-.795-.414l4.948-15.117 6.221-19 6.221-19.012 6.221-19 6.221-19.005 6.221-19.007L41.4 0q.372.291.738.589L36.9 16.61l-6.222 19.007-6.221 19-6.221 19-6.22 19.016-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(23.113 9.742)"
              />
              <path
                id="Path_962"
                d="M.763 127.16c-.255-.163-.509-.334-.763-.517l4.778-14.6L11 93.04l6.221-19 6.223-19.007 6.221-19 6.221-19.007L41.455 0c.253.177.506.357.754.542l-5.477 16.733-6.221 19.007-6.221 19-6.223 19.012-6.221 19L5.625 112.3z"
                fill="url(#linear-gradient)"
                transform="translate(21.371 8.493)"
              />
              <path
                id="Path_963"
                d="M.731 127.083c-.244-.2-.487-.4-.731-.614l4.536-13.856 6.221-19.007 6.221-19 6.221-19 6.221-19.007 6.22-19.015L41.4 0c.259.162.514.327.768.5l-5.681 17.343-6.221 19-6.221 19.011-6.221 19-6.221 19-6.22 19.017z"
                fill="url(#linear-gradient)"
                transform="translate(19.703 7.344)"
              />
              <path
                id="Path_964"
                d="M.7 126.693c-.235-.228-.467-.464-.7-.709l4.223-12.9 6.221-19 6.221-19.007 6.221-19 6.221-19.007 6.221-19L41.237 0q.395.225.783.456l-5.846 17.858-6.221 19.005-6.221 19.007-6.221 19-6.22 19.012-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(18.106 6.289)"
              />
              <path
                id="Path_965"
                d="M.67 126c-.225-.258-.448-.526-.67-.8l3.841-11.733 6.221-19 6.221-19.007 6.221-19 6.221-19 6.221-19.007L40.98 0c.265.137.53.276.795.418l-5.983 18.277L29.571 37.7l-6.22 19.006-6.221 19.007-6.221 19-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(16.577 5.325)"
              />
              <path
                id="Path_966"
                d="M.64 125.009q-.321-.433-.64-.89l3.392-10.36 6.222-19.007 6.221-19 6.221-19.007 6.221-19.005 6.221-19L40.628 0c.271.122.54.249.809.378l-6.092 18.611-6.221 19.005L22.9 57l-6.218 19.006-6.221 19.005-6.222 19.006z"
                fill="url(#linear-gradient)"
                transform="translate(15.114 4.449)"
              />
              <path
                id="Path_967"
                d="M.609 123.743C.4 123.419.2 123.09 0 122.76l2.875-8.786L9.1 94.968l6.221-19 6.221-19.005 6.221-19.007 6.221-19L40.181 0q.41.168.818.344L34.826 19.2l-6.221 19-6.221 19.016-6.221 19-6.221 19-6.22 19.017z"
                fill="url(#linear-gradient)"
                transform="translate(13.721 3.651)"
              />
              <path
                id="Path_968"
                d="M.584 122.187c-.2-.352-.392-.7-.584-1.059l2.3-7.02L8.518 95.1l6.221-19.007 6.221-19 6.221-19L33.4 19.077l6.221-19L39.646 0c.279.1.555.2.832.308l-.008.023-6.221 19.005-6.221 19.006-6.221 19-6.221 19-6.221 19.017-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(12.388 2.936)"
              />
              <path
                id="Path_969"
                d="M.575 120.406L0 119.314l1.687-5.152 6.221-19 6.221-19 6.221-19.018 6.221-19 6.221-19L39.013.127 39.055 0c.283.088.563.179.843.272l-.038.114-6.221 19.006-6.221 19L21.2 57.4l-6.224 19.009-6.221 19-6.22 19.01z"
                fill="url(#linear-gradient)"
                transform="translate(11.088 2.298)"
              />
              <path
                id="Path_970"
                d="M.6 118.565l-.6-1.027 1.113-3.4 6.221-19.003 6.221-19 6.221-19L26 38.118l6.221-19L38.438.106 38.473 0c.285.076.571.156.854.239l-.042.126-6.221 19.007-6.221 19-6.22 19.011L14.4 76.388l-6.221 19L1.96 114.4z"
                fill="url(#linear-gradient)"
                transform="translate(9.752 1.735)"
              />
              <path
                id="Path_971"
                d="M.579 116.728c-.2-.362-.392-.721-.579-1.076l.525-1.607 6.221-19 6.221-19.007 6.221-19.005 6.221-19 6.221-19.017 6.221-19V.005c.288.066.576.135.865.205L38.7.27l-6.221 19-6.223 19.012-6.221 19-6.221 19L7.593 95.3l-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(8.427 1.249)"
              />
              <path
                id="Path_972"
                d="M.566 114.686c-.194-.378-.381-.75-.566-1.12l6.122-18.7 6.221-19.006 6.221-19.007 6.221-19 6.221-19.007L37.173 0q.437.083.874.171L31.853 19.1l-6.222 19.007-6.22 19.005-6.221 19.006-6.221 19-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(7.142 .84)"
              />
              <path
                id="Path_973"
                d="M.537 112.441q-.279-.606-.537-1.2l5.442-16.629 6.221-19L17.884 56.6l6.221-19 6.221-19L36.41 0q.444.062.886.137l-6.123 18.712-6.221 19-6.221 19.011-6.221 19-6.221 19.01z"
                fill="url(#linear-gradient)"
                transform="translate(5.911 .51)"
              />
              <path
                id="Path_974"
                d="M.489 109.9q-.262-.679-.489-1.348l4.669-14.269 6.221-19.007 6.221-19 6.221-19.007 6.221-19L35.529 0c.3.032.6.064.9.1L30.4 18.518l-6.221 19-6.221 19.012-6.221 19-6.22 19.011z"
                fill="url(#linear-gradient)"
                transform="translate(4.773 .257)"
              />
              <path
                id="Path_975"
                d="M.393 106.866c-.15-.55-.282-1.1-.393-1.647l3.716-11.353L9.937 74.86l6.221-19 6.221-19L28.6 17.843 34.44 0c.3.017.609.038.913.065L29.447 18.1l-6.221 19.008-6.221 19-6.221 19.01-6.221 19.007z"
                fill="url(#linear-gradient)"
                transform="translate(3.815 .09)"
              />
              <path
                id="Path_976"
                d="M.1 102.855a21.5 21.5 0 0 1-.094-2.555l2.267-6.925 6.221-19 6.221-19.007 6.221-19 6.221-19L32.833 0c.307.006.615.015.923.026L28 17.6l-6.217 19.01-6.221 19-6.221 19.011-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(3.348 .005)"
              />
              <path
                id="Path_977"
                d="M0 91.972a37.59 37.59 0 0 0 .9-5.592v-.006l4.121-12.59 6.221-19 6.221-19.007 6.221-19.005L29.168.016c.312-.01.625-.016.937-.016l-5.573 17.027-6.221 19-6.221 19.012-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(4.909)"
              />
              <path
                id="Path_978"
                d="M.085 82.283Q.077 80.989 0 79.7l2.146-6.56 6.221-19.005 6.221-19 6.221-19.007L26.066.061q.474-.038.952-.061l-5.363 16.382-6.221 19.007-6.221 19-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(5.875 .061)"
              />
              <path
                id="Path_979"
                d="M.248 76.674Q.141 75.635 0 74.591l.718-2.2 6.221-19.003 6.221-19 6.223-19 5-15.268c.321-.042.645-.078.968-.111L20.23 15.637l-6.223 19-6.22 19.009-6.222 19.007z"
                fill="url(#linear-gradient)"
                transform="translate(5.391 .225)"
              />
              <path
                id="Path_980"
                d="M.319 71.854c-.1-.623-.207-1.245-.319-1.869l5.714-17.459 6.221-19.007 6.221-19L22.854.162q.488-.09.984-.162L19 14.773l-6.221 19-6.218 19.012-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(4.705 .506)"
              />
              <path
                id="Path_981"
                d="M.352 67.307C.238 66.718.119 66.128 0 65.534l4.581-14L10.8 32.532l6.221-19L21.378.225Q21.877.1 22.383 0L17.87 13.786l-6.221 19.006L5.428 51.8z"
                fill="url(#linear-gradient)"
                transform="translate(3.928 .909)"
              />
              <path
                id="Path_982"
                d="M.364 62.791c-.12-.576-.241-1.156-.364-1.736l3.486-10.649L9.707 31.4l6.221-19.007L19.886.3c.34-.105.684-.2 1.029-.3l-4.14 12.652-6.221 19.007-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(3.113 1.459)"
              />
              <path
                id="Path_983"
                d="M.36 58.141c-.121-.582-.24-1.164-.36-1.75l2.389-7.3 6.221-19 6.221-19 3.5-10.7c.349-.136.7-.265 1.059-.388l-3.712 11.339-6.22 19.005-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(2.299 2.189)"
              />
              <path
                id="Path_984"
                d="M.332 53.207Q.159 52.3 0 51.38l1.247-3.81 6.221-19.011 6.221-19.005L16.651.5q.542-.264 1.1-.5l-3.215 9.813-6.221 19-6.221 19.012z"
                fill="url(#linear-gradient)"
                transform="translate(1.529 3.134)"
              />
              <path
                id="Path_985"
                d="M.285 47.778Q.133 46.8 0 45.808l.015-.048 6.221-19 6.221-19.013L14.78.651Q15.342.315 15.925 0L13.3 8.005 7.084 27.012l-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(.851 4.358)"
              />
              <path
                id="Path_986"
                d="M.217 41.631Q.1 40.543 0 39.452l4.865-14.866 6.221-19L12.631.862Q13.221.42 13.844 0l-1.911 5.839-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(.312 5.943)"
              />
              <path
                id="Path_987"
                d="M.1 34.383C.053 33.536.019 32.69 0 31.85l3.267-9.978 6.221-19 .537-1.643Q10.667.592 11.356 0l-1.021 3.121-6.221 19z"
                fill="url(#linear-gradient)"
                transform="translate(0 8.077)"
              />
              <path
                id="Path_988"
                d="M0 25.11q.044-1.712.18-3.4l1.171-3.578L6.609 2.074Q7.362 1 8.219 0L2.2 18.394z"
                fill="url(#linear-gradient)"
                transform="translate(.003 11.227)"
              />
              <path
                id="Path_989"
                d="M0 8.825A38.3 38.3 0 0 1 2.889 0z"
                fill="url(#linear-gradient)"
                transform="translate(1.055 17.879)"
              />
            </g>
            <path
              id="Path_926"
              d="M11.307 53.813C21.681 43.8 35.905 38.735 48.986 32.547c8.612-4.075 15.633-9.836 23.3-15.293 19.5-13.876 44.112-25.016 63.748-10.3 16.364 12.264 23.669 40.7 10.995 61.352-4.384 7.142-10.663 11.818-17.671 15.122-4.207 1.984-9.633 3.147-12.778 7.268-3.316 4.348-3.419 10.925-4.133 16.049-1.061 7.627-2.208 15.643-5.918 22.6-8.512 15.971-21.937 13.508-34.636 3.8-1.655-1.264-35.086-25.68-45.547-29.169-9.316-3.108-19.038-7.45-23.676-15.726-5.26-9.381-2.24-21.512 4.618-30.044a47.256 47.256 0 0 1 4.019-4.393z"
              fill="url(#linear-gradient)"
              transform="rotate(-177 76.733 70.443)"
            />
            <path
              id="Path_990"
              fill="url(#linear-gradient)"
              stroke="rgba(0,0,0,0)"
              d="M148.338 51.452c2.453-14.186.221-28.05-9.464-38.834-8.659-9.642-21.453-13.123-33.583-12.56-2.265.105-2.779-.35-6.874.827s-6.563 1.882-9.508 3.88c-4.4 2.982-7.78 7.532-11.614 11.4A49.909 49.909 0 0 1 50.12 30.5c-7.964 1.294-16.072.459-24.072 1.4S9.685 35.978 4.759 43.274C1.219 48.516-.119 55.353.008 61.947.316 77.855 8.7 92.491 19.833 101.962s24.756 14.386 38.393 17.52c13.16 3.024 27.1 4.479 39.85-.516 20.558-8.056 45.237-38.46 50.262-67.514z"
              transform="translate(-4.019 5.44)"
            />
            <g id="Group_582" transform="translate(148.225 55.753)">
              <path
                id="Path_995"
                d="M.028.109A.217.217 0 0 1 .319.026L1.538.69a.207.207 0 0 1 .081.286.218.218 0 0 1-.292.082L.109.395A.207.207 0 0 1 .028.109z"
                fill="url(#linear-gradient)"
                transform="translate(3.576 3.043)"
              />
              <path
                id="Path_996"
                d="M.028.109A.217.217 0 0 1 .319.026l1.28.7a.206.206 0 0 1 .081.286.217.217 0 0 1-.292.083L.109.395A.207.207 0 0 1 .028.109z"
                fill="url(#linear-gradient)"
                transform="translate(.242 1.227)"
              />
              <path
                id="Path_997"
                d="M.028 1.432L.784.109a.217.217 0 0 1 .292-.083.207.207 0 0 1 .081.286L.4 1.635a.217.217 0 0 1-.292.083.207.207 0 0 1-.08-.286z"
                fill="url(#linear-gradient)"
                transform="translate(1.233 3.393)"
              />
              <path
                id="Path_998"
                d="M.028 1.374L.75.109a.218.218 0 0 1 .292-.083.207.207 0 0 1 .081.286L.4 1.577a.217.217 0 0 1-.292.083.207.207 0 0 1-.08-.286z"
                fill="url(#linear-gradient)"
                transform="translate(3.08 .218)"
              />
              <path
                id="Path_999"
                d="M.028.51a.218.218 0 0 1 .129-.1l1.416-.4a.212.212 0 0 1 .264.143.212.212 0 0 1-.149.261l-1.416.4A.213.213 0 0 1 .008.67a.207.207 0 0 1 .02-.16z"
                fill="url(#linear-gradient)"
                transform="translate(0 2.779)"
              />
              <path
                id="Path_1000"
                d="M.028.491a.215.215 0 0 1 .129-.1L1.5.008a.212.212 0 0 1 .264.144.212.212 0 0 1-.149.261L.272.795A.213.213 0 0 1 .008.651a.207.207 0 0 1 .02-.16z"
                fill="url(#linear-gradient)"
                transform="translate(3.688 1.753)"
              />
              <path
                id="Path_1001"
                d="M.028.109a.214.214 0 0 1 .129-.1.212.212 0 0 1 .264.143l.394 1.387a.214.214 0 0 1-.415.117L.008.269a.206.206 0 0 1 .02-.16z"
                fill="url(#linear-gradient)"
                transform="translate(1.817)"
              />
              <path
                id="Path_1002"
                d="M.028.109a.217.217 0 0 1 .129-.1.212.212 0 0 1 .263.143L.815 1.54a.214.214 0 0 1-.415.116L.008.269a.207.207 0 0 1 .02-.16z"
                fill="url(#linear-gradient)"
                transform="translate(2.825 3.546)"
              />
            </g>
          </g>
        </g>
      </g>
      <text
        id="_88_"
        fill="#fff"
        font-family="Museo-900, Museo"
        font-size="48px"
        font-weight="900"
        transform="translate(42.745 109.14)"
      >
        <tspan x="0" y="0">
          {props.percentage}%
        </tspan>
      </text>
    </svg>
  );
}

export default SvgComponent;
